<template>
    <v-layout>
        <v-flex>
            <v-menu
                ref="datePicker"
                :close-on-content-click="false"
                v-model="datePicker"
                :nudge-right="100"
                :disabled="disabled"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                    <div class="text-field-wrapper" id="dpk">
                        <v-text-field
                                ref="textField"
                                outlined
                                :label="label"
                                prepend-inner-icon="event"
                                :disabled="disabled"
                                v-model.trim="dateTextField"
                                persistent-hint
                                hint="MM-DD-YYYY"
                                :error-messages="errorMesgFn"
                                error-count="2"
                                v-mask="'##-##-####'"
                                required
                                @blur="saveDate(dateTextField)"
                                @click:prepend-inner="showCal($event, on)"
                        >
                        </v-text-field>
                    </div>
                </template>
                <v-date-picker
                    ref="picker"
                    no-title
                    v-model="pickerDate"
                    :max="maxDate"
                    :min="minDate"
                    @change="handleDatePickerChanged"
                ></v-date-picker>
            </v-menu>
        </v-flex>
    </v-layout>
</template>

<script>
    import moment from "moment";
    import { DATE_FORMAT } from "../../shared/enums/DateFormats";

    export default {
        name: "DatePicker",
        props: ["errorFn", "labelProp", "disabledProp", "valueProp", "minDateProp", "maxDateProp"],
        data() {
            return {
                datePicker: false,
                pickerDate: null,
                dateError: null
            };
        },
        computed: {
            errorMesgFn() {
                if (this.dateError) {
                    return [this.dateError];
                }
                return this.errorFn;
            },
            label() {
                return this.labelProp;
            },
            disabled() {
                return !!!!this.disabledProp;
            },
            dateTextField: {
                get() {
                    return moment(this.pickerDate, DATE_FORMAT.ISO8001).format(DATE_FORMAT.APP);
                },
                set(value) {
                    if (value.length > 0) {
                        if (this.isDateValid(value)) {
                            this.pickerDate = new Date(value).toISOString().substr(0, 10);
                            this.dateError = null;
                        } else {
                            this.dateError = "Invalid Date";
                        }
                    }
                }
            },
            minDate() {
                if (!this.minDateProp) {
                    const date = new Date();
                    date.setFullYear(date.getFullYear() - 108);
                    return moment(date.toLocaleDateString(), DATE_FORMAT.LOCALE).format(DATE_FORMAT.ISO8001);
                }
                return this.minDateProp;
            },
            maxDate() {
                if (!this.maxDateProp) {
                    return moment(new Date().toLocaleDateString(), DATE_FORMAT.LOCALE).format(DATE_FORMAT.ISO8001);
                }
                return this.maxDateProp;
            }
        },
        methods: {
            saveDate(date) {
                if (this.isDateValid(date)) {
                    this.$emit("dateValue", date);
                } else {
                    this.dateError = "Invalid Date";
                }
            },
            handleDatePickerChanged(date) {
                const formatedDate = moment(date, DATE_FORMAT.ISO8001).format(DATE_FORMAT.APP);
                this.dateError = null;
                this.$refs.datePicker.save(formatedDate);
                this.saveDate(formatedDate);
            },
            showCal(event, on) {
                on.click(event);
            },
            isDateValid(date) {
                //MM-dd-yyyy validator
                const dateValidator = /(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])-((19|20)\d\d)$/;

                if (dateValidator.test(date)
                    && moment(date, DATE_FORMAT.APP).isBetween(this.minDate, this.maxDate, null, '[]')) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        watch: {
            datePicker(value) {
                if (value && !this.pickerDate) {
                    setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
                } else {
                    setTimeout(() => (this.$refs.picker.activePicker = "DATE"));
                }
            },
            valueProp: {
                immediate: true,
                handler: function(val) {
                    if(this.isDateValid(val))
                    {
                        this.dateTextField = val;
                    }
                },
            },
        }
    };
</script>

<style>
   #dpk label.v-label--active {
       left: -28px !important;
   }
</style>